import axios from "axios"
import store from '../store';
import router from '../router'
import Cookie from 'js-cookie'

axios.defaults.baseURL = process.env.API_ROOT;


// 添加请求拦截器
// 请求添加 config参数 noLoading(boolean值)控制全局loading
let requestCount = 0
axios.interceptors.request.use(function(config) {
    requestCount++
    config.headers["token"] = (store.state.user.token || Cookie.get('mifiToken')) || localStorage.getItem('agentToken') || '';
    if (!config.noLoading) {
        store.commit('req', true)
    }
    // 在发送请求之前做些什么
    return config;
}, function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(function(response) {
    requestCount--
    setTimeout(() => {
        //分发SetRequest这个action到vuex，并携带false      
        requestCount == 0 && store.commit('req', false)
    }, 100);

    // 当响应数据为为token失效，则重新登录
    if (response.data.code == 1000) {
        store.commit("Logout");
        localStorage.removeItem('agentToken')
        Cookie.remove('mifiToken');
        router.replace({name: sessionStorage.getItem('fastLogin') || 'login'})
        location.reload();
        return;
    }
    return response;
}, function(error) {
    requestCount--
    store.commit('req', false)
    return Promise.reject(error);
});
export default axios


// WEBPACK FOOTER //
// ./src/utils/http.js